import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyarabic]'
})
export class OnlyarabicDirective {
  private regex: RegExp = /^[^a-zA-Z]*$/; // Exclude English letters

  @HostListener('input', ['$event'])
  onInputChange(event: InputEvent): void {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[a-zA-Z]/g, ''); // Remove English letters
    if (input.value !== sanitizedValue) {
      input.value = sanitizedValue;
      input.dispatchEvent(new Event('input')); // Trigger Angular's two-way binding
    }
  }
}
